export default "__VITE_ASSET__528009d0__"